
import React from "react";

const ServiceSection = ({ service, index }) => {
  // Sort features by length (longest to shortest)
  const sortedFeatures = [...service.features].sort((a, b) => b.length - a.length);

  return (
    <section 
      id={service.id} 
      className={`py-16 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} scroll-mt-24`}
    >
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-4 mb-4">
            {service.icon && <service.icon className="h-8 w-8 text-orange-500" />}
            <h2 className="text-3xl font-bold text-gray-900">{service.title}</h2>
          </div>
          
          <div>
            <p className="text-gray-700 text-lg mb-4 leading-relaxed">{service.fullDescription}</p>
            
            <ul className="list-disc ml-6 space-y-1 text-gray-700 text-base">
              {sortedFeatures.map((feature, idx) => (
                <li key={idx} className="text-[17px]">{feature}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(ServiceSection);
